const customSwiper = {
	classes: {
		swiper: "custom-swiper",
	},
	is: (swiper, classname) => {
		return $(swiper.el).hasClass(classname);
	},
};


const sections = {
	video: "video-section",
};

$.fn.isInViewport = function (extra_space) {
	if (isNaN(extra_space)) {
	  extra_space = 0;
	}

	var elementTop = $(this).offset().top - extra_space;
	var elementBottom = elementTop + $(this).outerHeight() + extra_space;

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

function updateUrl() {
    // var menuButtons = document.querySelector('.menu_button');
    var handle = document.querySelector(".menu_button.active").dataset.handle;
    var url = window.location.href.replace(window.location.hash, ""),
    append_to_url = ("#" + handle),
    url_new = false;

      if (url.indexOf(append_to_url) == -1
          && url.indexOf("legal") > -1
		  || url.indexOf(append_to_url) == -1
          && url.indexOf("customer-service") > -1
      ) {
          url_new = url + append_to_url;
      }
      url_new && (window.location.href = url_new);


}

function initNewSwiper(swiper_selector, thumbs_of_swiper = null) {
	/*
    swiper_selector -> to prevent conflicts it is better to use id
    the swipe settings could be assigned in html with data attributes to the swiper_selector
    if something is not set - it gets a default val
    feel free to bring more stuff :)

    thumbs_of_swiper -> when slider has thumbs: the function is called like initBangSwiper('thumbs-slider', 'main-slider')
      after the thumbs-slider is initialized, it will call automaticaly init of the main-slider
  */
	var swiper_element = $(swiper_selector);
	var effect = swiper_element.data("effect") ? $(swiper_element).data("effect") : "slide";

	//speed and autoplayDelay can accept value 0
	var speed = typeof swiper_element.data("speed") != "undefined" ? $(swiper_element).data("speed") : 2500;

	/*set data-autoplay="false" to disable autoplay; any other value in ms like 1000 2000 will activate the autoplay*/
	var autoplayDelay = typeof swiper_element.data("autoplay") != "undefined" ? $(swiper_element).data("autoplay") : 1000;
	var autoplayMobile = typeof swiper_element.data("autoplay-mobile") != "undefined" ? $(swiper_element).data("autoplay-mobile") : 5000;

	var autoplayMobileSettings = false;

	if (autoplayMobile) {
		var autoplayMobileSettings = {
			delay: autoplayMobile,
			disableOnInteraction: false,
		};
	}

	var autoplaySubSettings = false;
	if (autoplayDelay) {
		var autoplaySubSettings = {
			delay: autoplayDelay,
			disableOnInteraction: false,
		};
	}

	var loop = swiper_element.data("loop") === true;

	var perViewMobile = swiper_element.data("per-view-mobile") ? $(swiper_element).data("per-view-mobile") : 1;
	var perViewTablet = swiper_element.data("per-view-tablet") ? $(swiper_element).data("per-view-tablet") : 1;
	var perViewTablet__big = swiper_element.data("per-view-tablet-big") ? $(swiper_element).data("per-view-tablet-big") : false;
	var perViewDesktop = swiper_element.data("per-view-desktop") ? $(swiper_element).data("per-view-desktop") : 1;

	var betweenMobile = swiper_element.data("between-mobile") ? $(swiper_element).data("between-mobile") : 15;
	var betweenTablet = swiper_element.data("between-tablet") ? $(swiper_element).data("between-tablet") : 15;
	var betweenDesktop = swiper_element.data("between-desktop") ? $(swiper_element).data("between-desktop") : 15;

	var initialSlideMobile = swiper_element.data("initial-slide-mobile") ? $(swiper_element).data("initial-slide-mobile") : 0;
	var initialSlideTablet = swiper_element.data("initial-slide-tablet") ? $(swiper_element).data("initial-slide-tablet") : 0;

	var mobile_centered = swiper_element.data("mobile-centered") ? $(swiper_element).data("mobile-centered") : false;
	var tablet_centered = swiper_element.data("tablet-centered") ? $(swiper_element).data("tablet-centered") : false;
	var desktop_centered = swiper_element.data("desktop-centered") ? $(swiper_element).data("desktop-centered") : false;

	var custom_pagination = swiper_element.data("custom-pagination") ? $(swiper_element).data("custom-pagination") : false;

	var mobile_disabled = swiper_element.data("mobile-disabled") ? false : true;
	var tablet_disabled = swiper_element.data("tablet-disabled") ? false : true;
	var desktop_disabled = swiper_element.data("desktop-disabled") ? false : true;

	var slider_direction = swiper_element.data("slider-direction") ? $(swiper_element).data("slider-direction") : "horizontal";

    var touch_threshold = swiper_element.data("touch-threshold") ? $(swiper_element).data("touch-threshold") : 0;

	var navigationSubSettings = false;

	var swiper_f = new Swiper(swiper_selector, {
		effect: effect,
		slidesPerView: perViewMobile,
		spaceBetween: betweenMobile,
		loop: loop,
		speed: speed,
		freeMode: {
			enabled: false,
			momentumRatio: 0.2,
			momentumBounce: false,
			momentumVelocityRatio: 1,
			sticky: true,
		},
		noSwipingClass: "disabled",
		noSwiping: true,
		mousewheel: false,
		direction: slider_direction,
		observer: true,
		observerUpdate: true,
		observeSlideChildren: true,
        threshold: touch_threshold,
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true,
		},
		pagination: {
			el: swiper_selector + " .swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				var custom_pagination_content = '<span class="' + className + '"></span>';

				if (custom_pagination) {
					custom_pagination_content =
						'<div class="swiper-bullet-with-image ' +
						className +
						'"><div class="swiper-bulet-image-holder"><img src="' +
						$("#lookbook_img_" + index).data("image") +
						'"></div></div>';
				}
				return custom_pagination_content;
			},
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		breakpoints: {
			320: {
				spaceBetween: betweenMobile,
				autoplay: autoplayMobileSettings,
				centeredSlides: mobile_centered,
				initialSlide: initialSlideMobile,
				enabled: mobile_disabled,
			},
			750: {
				/*750 and up to next*/ slidesPerView: perViewTablet,
				spaceBetween: betweenTablet,
				autoplay: autoplayMobileSettings,
				centeredSlides: tablet_centered,
				initialSlide: initialSlideTablet,
				enabled: tablet_disabled,
			},
			989: {
				/*990 and up to next*/ slidesPerView: perViewTablet__big ? perViewTablet__big : perViewDesktop,
				spaceBetween: betweenDesktop,
				centeredSlides: desktop_centered,
				enabled: desktop_disabled,
			},
			1080: {
				centeredSlides: desktop_centered,
				slidesPerView: perViewDesktop,
				spaceBetween: betweenDesktop,
				autoplay: autoplaySubSettings,
				enabled: desktop_disabled,
			},
		},
		thumbs: {
			swiper: thumbs_of_swiper,
		},
		navigation: navigationSubSettings,
		on: {
			init: function(swiper){
				$(swiper_selector + ` .swiper-buttons-custom .swiper-button-prev`).css('opacity',0.3);
				$(swiper_selector + ` .swiper-buttons-custom .swiper-button-prev`).css('pointer-events','none');
			},
			slideChangeTransitionStart: function (swiper) {
				if (!$(swiper_selector + ` .swiper-slide:first`).hasClass("swiper-slide-active")) {
					$(swiper_selector + ` .swiper-buttons-custom .swiper-button-prev`).css('opacity',1);
					$(swiper_selector + ` .swiper-buttons-custom .swiper-button-prev`).css('pointer-events','all');
				}
				if (!swiper.isEnd) {
					$(swiper_selector + ` .swiper-buttons-custom .swiper-button-next`).css('opacity',1);
					$(swiper_selector + ` .swiper-buttons-custom .swiper-button-next`).css('pointer-events','all');
				}
			},
			reachBeginning: function () {
				$(swiper_selector + ` .swiper-buttons-custom .swiper-button-prev`).css('opacity',0.3)
				$(swiper_selector + ` .swiper-buttons-custom .swiper-button-prev`).css('pointer-events','none');
			},
			reachEnd: function () {
				$(swiper_selector + ` .swiper-buttons-custom .swiper-button-next`).css('opacity',0.3)
				$(swiper_selector + ` .swiper-buttons-custom .swiper-button-next`).css('pointer-events','none');
			},
		},
	});

	swiper_f.init();

	$(".swiper-button-next").on("click", function () {
		var section = $(this).data("for-section");
		if (section && swiper_selector == "#" + section) {
			swiper_f.slideNext();
		}
	});

	$(".swiper-button-prev").on("click", function () {
		var section = $(this).data("for-section");
		if (section && swiper_selector == "#" + section) {
			swiper_f.slidePrev();
		}
	});

	return swiper_f;
}

$(document).ready(function () {
    $(`.${customSwiper.classes.swiper}`).each(function () {
		initNewSwiper("#" + $(this).attr("id"));
	});

	//Adds a custom class so we can check whether the mega menu is opened
	const mutationHeader = () => {
		const callback = function (mutationsList) {
			for (const mutation of mutationsList) {
			  if (mutation.type === "attributes") {
				if(mutation.attributeName.includes("open")) {
				  // Checks if the mega menu is opened and adds some modifications on it
				  if (mutation.target.hasAttribute('open')) {
					const header = $('.header-wrapper');
					$(header).addClass('open');
				  } else {
					const header = $('.header-wrapper');
					$(header).removeClass('open');
				  }
				}
			  }
			}
		};

		// Create an observer instance linked to the callback function
		const observer = new MutationObserver(callback);
		const megaMenu = document.getElementsByClassName("mega-menu");
		const searchMenu = document.getElementsByTagName("details-modal")[0].children[0];
		// Start observing the target node for configured mutations
		observer.observe(searchMenu, { attributes: true });

        megaMenu.forEach((menu) => {
          observer.observe(menu, { attributes: true });
        })
	}

	// Changes the color of the nav on scroll
	const changeColorOnScrollNav = () => {
		const header = $('.header-wrapper');

		$(window).on("scroll", function() {
			if($(window).scrollTop() > 50) {
				$(header).addClass("scrolled");
				alignWithHeader();
			} else {
			   $(header).removeClass("scrolled");
			   alignWithHeader();
			}
		});
	}

	mutationHeader();
	changeColorOnScrollNav();
})


$(document).ready(function () {
    $("#NewsletterForm--footer").click(function(){
        $("#newsletter-checkbox").parent().removeClass('opacity');
    });
})

$(document).ready(function () {
	$(".boost-pfs-filter-products").removeClass('grid--4-col-desktop');
    $(".view3").click(function(){
        $(".boost-pfs-filter-products").removeClass('grid--4-col-desktop');

		$(".view4").removeClass('active-page');
		$(".view3").addClass('active-page');
    });
	$(".view4").click(function(){
        $(".boost-pfs-filter-products").addClass('grid--4-col-desktop');
		$(".view3").removeClass('active-page');
		$(".view4").addClass('active-page');
    });
	$(".view1").click(function(){
        $(".boost-pfs-filter-products").removeClass('grid--2-col');
		$(".boost-pfs-filter-products").addClass('grid--1-col');
		$(".view2").removeClass('active-page');
		$(".view1").addClass('active-page');
    });
	$(".view2").click(function(){
        $(".boost-pfs-filter-products").removeClass('grid--1-col');
		$(".boost-pfs-filter-products").addClass('grid--2-col');
		$(".view1").removeClass('active-page');
		$(".view2").addClass('active-page');
    });
})

$(window).on("scroll", function() {
	const body = $('.body');
		if($(window).scrollTop() > 50) {
			$(body).addClass("scrolled");
		} else {
		   $(body).removeClass("scrolled");
		}
});

// PDP Images

// let observer = new IntersectionObserver(
// 	(entries, observer) => {
// 	  entries.forEach(entry => {
// 		/* Here's where we deal with every intersection */
// 	  });
// 	},
// 	{rootMargin: "0px 0px -200px 0px"});

// if ('IntersectionObserver' in window) {
//     console.log("Your browser supports IntersectionObserver");
// } else {
//     console.log("Your browser does not support IntersectionObserver");
// }

// const targets = document.querySelectorAll("img");

// const lazyLoad = (target)=>{
//   const io = new IntersectionObserver((entries,observer)=>{
//       entries.forEach(entry=>{
//           if(entry.isIntersecting){
//               const img=entry.target;
//               const src=img.getAttribute("data-src");

//               img.setAttribute("src",src);
//               img.classList.add("fade");
//               observer.disconnect();
//           }
//       })
//   },{threshold:[0.7]});

//   io.observe(target);
// }
// targets.forEach(lazyLoad);

// cookie stuff
function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function checkACookieExists(cname) {
	if (document.cookie.split(";").some((item) => item.trim().startsWith(cname + "="))) {
		return true;
	}

	return false;
}

// Taken from the original site for the Cookie Bar
function GetCookie(name) {
	var arg=name+"=";
	var alen=arg.length;
	var clen=document.cookie.length;
	var i=0;
	while (i<clen) {
	  var j=i+alen;
	  if (document.cookie.substring(i,j)==arg)
		return "here";
	  i=document.cookie.indexOf(" ",i)+1;
	  if (i==0) break;
	}
	return null;
  }
  function testFirstCookie(){
	  var offset = new Date().getTimezoneOffset();
	  if ((offset >= -180) && (offset <= 0)) { // European time zones
		  var visit=GetCookie("cookieCompliancyAccepted");
		  if (visit==null){
			 $("#myCookieConsent").delay(500).fadeIn(750);	// Show warning
		 } else {
			  $("#myCookieConsent").hide();
		 }
	  }
  }
  $(document).ready(function(){
	  $("#cookieButton").on( "click", function() {
		  console.log('Akzeptieren');
		  var expire=new Date();
		  expire=new Date(expire.getTime()+7776000000);
		  document.cookie="cookieCompliancyAccepted=here; expires="+expire+";path=/";
		  $("#myCookieConsent").fadeOut(175);
	  });
	  testFirstCookie();
  });

// ClearAllFilters mobile buttons workaround
$(document).ready(function(){
	$(document).on('click', '.boost-pfs-filter-toolbar-top-mobile .boost-pfs-filter-clear-all, .boost-pfs-filter-mobile-footer .boost-pfs-filter-clear-all', function(){
    $('.facets__wrapper .boost-pfs-filter-clear-all').trigger('click');
	});

	$('.product-media-modal__content').on('scroll', function() {
		$('.product-media-modal__content .global-media-settings').each(function(index){
			if($(this).isInViewport()){
				$('.gallery-pagination-wrapper button').eq(index+1).removeClass('current');
				$('.gallery-pagination-wrapper button').eq(index-1).removeClass('current');
				$('.gallery-pagination-wrapper button').eq(index).addClass('current');
			}
		});
	});

	let url = window.location.href;
	if(url.includes('#shipping') || url.includes('#returns-exchanges') || url.includes('#size-chart') || url.includes('#f-q')){
		$('html, body').animate({
			scrollTop: 0
		}, 'slow');
	}
});

//   Add menu data-handle menu 	

$(document).ready(function() {
    const allParagraphs = $('.help__accordion-panel p')

    $(allParagraphs).each(function() {
      if ($(this).text().length == 0) {
        $(this).remove();
      } else {
        $(this).addClass('p_accordion-content')
      }
    })

    var acc = document.getElementsByClassName("help__accordion");
    var i;
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          for (let k = 0; k < acc.length; k++) {
            acc[k].classList.remove("active");
            var panel_e = acc[k].nextElementSibling;
            panel_e.style.maxHeight = null;
          }
          this.classList.toggle("active");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  })

	function alignWithHeader(){
		const selector = [
			".drawer__header",
			".modal_size_help .modal_header_holder",
			".boost-pfs-filter-mobile-toolbar"
		]
		const headerScrolled = $('#shopify-section-header').find('.scrolled')
		const header = $('#shopify-section-header').height();
		const announcement = !headerScrolled.length ? $('#shopify-section-announcement-bar').height() : 0;
		$(selector.join(',')).css('min-height', header + announcement + 'px')
	}

    $(document).ready(function() {
	  alignWithHeader();
      const menuButtons = $('.menu_button:not([data-handle="email"]):not([data-handle="monday-friday-10am-5pm-est"])');
      function selectFirstCategory() {
		const hash = window.location.hash.slice(1);
        const firstCategory = $(`.menu_button[data-handle= "${hash}"]`);
        const firstCategoryName = $(firstCategory).data('handle');
        const allQuestions = $('.content-block');


        $(firstCategory).addClass('active');

        $(allQuestions).each(function() {
          const questionHandle = $(this).data('handle');

          if (questionHandle == firstCategoryName) {
            $(this).show();
          } else {
            $(this).hide();
          }
        })

      }

	  $(menuButtons).click(function() {
			$(menuButtons).removeClass('active');
			const button = $(this);
			const buttonHandle = $(this).data('handle');
			const allQuestions = $('.content-block');
	
			$(button).addClass('active');
			$('html, body').animate({
				scrollTop: 0
			}, 'slow');
	
			$(allQuestions).each(function() {
				const questionHandle = $(this).data('handle');
	
				if (questionHandle == buttonHandle) {
					$(this).show();
				} else {
					$(this).hide();
				}
			});
	
			updateUrl();
	});
	

      selectFirstCategory();
	//   updateUrl();
	  	//boost pagination buttons scroll
		setTimeout(() => {
			const boostPaginationButtons = $('.boost-pfs-filter-bottom-pagination .pagination__item');

			if(boostPaginationButtons.length){
				$(document).on('click', '.boost-pfs-filter-bottom-pagination .pagination__item', function(){
					$('html, body').animate({
						scrollTop: $('#main-collection-filters').offset().top-200
					}, 'slow');
				});
			}
		},3000);
    })